function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useReducer, useCallback, useEffect, useMemo } from 'react';
import { useContext } from 'react';
import { clearAllAction, getFilterReducer, updateFilterAction, updateFilterLabelAction } from './Filter/filterReducer';
export var filterContext = /*#__PURE__*/ React.createContext({
    onFilterItemChange: function() {
    /* */ },
    onFilterItemLabelChange: function() {
    /* */ },
    onClearFilters: function() {
    //
    },
    onTableSort: function() {
    //
    },
    getDefaultValueByName: function() {
        return '';
    },
    filterValues: {},
    filterLabels: {}
});
export var useFilter = function() {
    return useContext(filterContext);
};
export var FilterProvider = function(param) {
    var _param_onFilterUpdated = param.onFilterUpdated, onFilterUpdated = _param_onFilterUpdated === void 0 ? function() {
    //
    } : _param_onFilterUpdated, children = param.children, _param_defaultFilterValues = param.defaultFilterValues, defaultFilterValues = _param_defaultFilterValues === void 0 ? {} : _param_defaultFilterValues, extraFilterReducer = param.extraFilterReducer;
    var defaultFilter = Object.entries(defaultFilterValues).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[key] = {
            value: value,
            label: []
        };
        return acc;
    }, {});
    var _useReducer = _sliced_to_array(useReducer(getFilterReducer(extraFilterReducer), {
        filter: defaultFilter || {},
        meta: {}
    }), 2), state = _useReducer[0], dispatch = _useReducer[1];
    var stateString = JSON.stringify(state);
    var dispatchUpdateFilter = useCallback(function(name, value, label) {
        dispatch(updateFilterAction(name, value, label));
    }, [
        dispatch
    ]);
    var dispatchUpdateFilterLabel = useCallback(function(name, label) {
        dispatch(updateFilterLabelAction(name, label));
    }, [
        dispatch
    ]);
    var dispatchClearFilters = useCallback(function(keys) {
        dispatch(clearAllAction(keys));
    }, [
        dispatch
    ]);
    var getDefaultValueByName = useCallback(function(name) {
        var _defaultFilter_name;
        return (_defaultFilter_name = defaultFilter[name]) === null || _defaultFilter_name === void 0 ? void 0 : _defaultFilter_name.value;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(defaultFilter)
    ]);
    var filterValues = useMemo(function() {
        return Object.entries(state.filter).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], filter = _param[1];
            acc[key] = filter.value;
            return acc;
        }, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stateString
    ]);
    var filterLabels = useMemo(function() {
        return Object.entries(state.filter).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], filter = _param[1];
            acc[key] = filter.label;
            return acc;
        }, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stateString
    ]);
    var onTableSort = useCallback(function(type) {
        var _ref = _sliced_to_array(filterValues['sort_by'] || [], 2), currentSort = _ref[0], currentDirection = _ref[1];
        var newDirection = currentSort === type ? currentDirection === 'asc' ? 'desc' : null : 'asc';
        if (!newDirection) {
            dispatchUpdateFilter('sort_by', undefined);
        } else {
            dispatchUpdateFilter('sort_by', [
                type,
                newDirection
            ]);
        }
    }, [
        filterValues,
        dispatchUpdateFilter
    ]);
    useEffect(function() {
        onFilterUpdated(filterValues);
        localStorage.setItem('projectsFilter', JSON.stringify(filterValues));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stateString
    ]);
    return /*#__PURE__*/ React.createElement(filterContext.Provider, {
        value: {
            onFilterItemChange: dispatchUpdateFilter,
            onFilterItemLabelChange: dispatchUpdateFilterLabel,
            onClearFilters: dispatchClearFilters,
            onTableSort: onTableSort,
            getDefaultValueByName: getDefaultValueByName,
            filterValues: filterValues,
            filterLabels: filterLabels
        }
    }, children);
};
